import React from 'react';

const Stats = () => {
  const stats = [
    { 
      number: '10+', 
      label: 'PROJECTS DELIVERED',
      description: 'Successfully completed AI solutions across industries'
    },
    { 
      number: '60-65%', 
      label: 'COST SAVINGS',
      description: 'Average reduction in development costs for clients'
    },
    { 
      number: '2-4', 
      label: 'WEEKS TO START',
      description: 'Quick deployment with our startup-friendly approach'
    },
    { 
      number: '100%', 
      label: 'CLIENT SATISFACTION',
      description: 'Every project delivered with guaranteed results'
    }
  ];

  return (
    <section className="stats-section py-5" style={{
      background: 'linear-gradient(135deg, #1e293b 0%, #334155 100%)',
      position: 'relative',
      overflow: 'hidden'
    }}>
      {/* Background Pattern */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: `
          radial-gradient(circle at 20% 80%, rgba(59, 130, 246, 0.06) 0%, transparent 50%),
          radial-gradient(circle at 80% 20%, rgba(30, 64, 175, 0.05) 0%, transparent 50%)
        `,
        zIndex: 1
      }}></div>

      <div className="container" style={{ position: 'relative', zIndex: 2 }}>
        <div className="row justify-content-center text-center mb-5">
          <div className="col-lg-8">
            <h2 style={{
              fontSize: 'clamp(2rem, 4vw, 3rem)',
              fontWeight: '700',
              color: '#ffffff',
              marginBottom: '1rem'
            }}>
              Proven Track Record
            </h2>
            <p style={{
              fontSize: '1.1rem',
              color: 'rgba(255, 255, 255, 0.8)',
              lineHeight: '1.6',
              maxWidth: '600px',
              margin: '0 auto'
            }}>
              Our numbers speak for themselves. Here's what we've achieved for our clients.
            </p>
          </div>
        </div>

        <div className="row text-center g-3">
          {stats.map((stat, index) => (
            <div key={index} className="col-12 col-sm-6 col-md-3 mb-3">
              <div style={{
                background: 'rgba(255, 255, 255, 0.1)',
                border: '1px solid rgba(255, 255, 255, 0.2)',
                borderRadius: '16px',
                padding: 'clamp(1.5rem, 4vw, 2rem) clamp(1rem, 3vw, 1.5rem)',
                backdropFilter: 'blur(10px)',
                transition: 'all 0.3s ease',
                height: '100%',
                minHeight: '140px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center'
              }}>
                <div style={{
                  fontSize: 'clamp(2rem, 6vw, 3.5rem)',
                  fontWeight: '800',
                  color: '#0ea5e9',
                  marginBottom: '0.5rem',
                  lineHeight: '1'
                }}>
                  {stat.number}
                </div>
                <div style={{
                  fontSize: 'clamp(0.8rem, 2.5vw, 0.9rem)',
                  color: '#ffffff',
                  fontWeight: '600',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                  marginBottom: '0.5rem',
                  lineHeight: '1.4',
                  textAlign: 'center'
                }}>
                  {stat.label}
                </div>
                <div style={{
                  fontSize: 'clamp(0.7rem, 2vw, 0.8rem)',
                  color: 'rgba(255, 255, 255, 0.7)',
                  lineHeight: '1.4',
                  textAlign: 'center'
                }}>
                  {stat.description}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Additional Trust Indicators */}
        <div className="row justify-content-center mt-5">
          <div className="col-lg-8 text-center">
            <div style={{
              background: 'rgba(255, 255, 255, 0.1)',
              border: '1px solid rgba(255, 255, 255, 0.2)',
              borderRadius: '16px',
              padding: '2rem',
              backdropFilter: 'blur(10px)'
            }}>
              <h4 style={{
                color: '#ffffff',
                fontSize: '1.3rem',
                fontWeight: '600',
                marginBottom: '1rem'
              }}>
                Why Clients Choose Vallen AI
              </h4>
              <div style={{
                display: 'flex',
                justifyContent: 'center',
                gap: 'clamp(1rem, 4vw, 2rem)',
                flexWrap: 'wrap',
                alignItems: 'center'
              }}>
                <div style={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  gap: '0.5rem',
                  flex: '1 1 auto',
                  minWidth: 'fit-content',
                  justifyContent: 'center'
                }}>
                  <i className="bi bi-check-circle" style={{ color: '#0ea5e9', fontSize: 'clamp(1rem, 3vw, 1.2rem)' }}></i>
                  <span style={{ 
                    color: 'rgba(255, 255, 255, 0.9)',
                    fontSize: 'clamp(0.8rem, 2.5vw, 1rem)',
                    whiteSpace: 'nowrap'
                  }}>8-12 Week Delivery</span>
                </div>
                <div style={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  gap: '0.5rem',
                  flex: '1 1 auto',
                  minWidth: 'fit-content',
                  justifyContent: 'center'
                }}>
                  <i className="bi bi-check-circle" style={{ color: '#0ea5e9', fontSize: 'clamp(1rem, 3vw, 1.2rem)' }}></i>
                  <span style={{ 
                    color: 'rgba(255, 255, 255, 0.9)',
                    fontSize: 'clamp(0.8rem, 2.5vw, 1rem)',
                    whiteSpace: 'nowrap'
                  }}>Guaranteed ROI</span>
                </div>
                <div style={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  gap: '0.5rem',
                  flex: '1 1 auto',
                  minWidth: 'fit-content',
                  justifyContent: 'center'
                }}>
                  <i className="bi bi-check-circle" style={{ color: '#0ea5e9', fontSize: 'clamp(1rem, 3vw, 1.2rem)' }}></i>
                  <span style={{ 
                    color: 'rgba(255, 255, 255, 0.9)',
                    fontSize: 'clamp(0.8rem, 2.5vw, 1rem)',
                    whiteSpace: 'nowrap'
                  }}>Enterprise Security</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Stats; 